module.exports = __webpack_public_path__ + "static/media/inspiron.4b5427d0.jpg";